import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  SxProps,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IControlledRadioButtons {
  title: string;
  titleSx?: SxProps;
  radioColor?: string;
  isDirectionRow: boolean;
  radioGroupSx?: SxProps;
  values: string[];
  valueSx?: SxProps;
  onChange: Function;
  value?: string;
}

export const ControlledRadioButtonsPurple = ({
  title,
  titleSx,
  isDirectionRow = true,
  radioColor,
  radioGroupSx,
  values,
  valueSx,
  onChange,
  value,
}: IControlledRadioButtons) => {
  const isDesktop = useIsDesktop();

  return (
    <FormControl component='fieldset'>
      <FormLabel
        sx={{
          mb: isDesktop ? '18px' : '14px',
          color: 'inherit',
          fontWeight: 700,
          fontSize: isDesktop ? '20px' : '18px',
          lineHeight: '24px',
          textAlign: 'center',
          fontFamily: 'inherit',
          ...titleSx,
        }}
      >
        {title}
      </FormLabel>
      <FormLabel component='legend'>{title}</FormLabel>
      <RadioGroup
        defaultValue={values[0]}
        row={isDirectionRow}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value)
        }
        sx={{
          gap: '10px',
          ...radioGroupSx,
        }}
      >
        {values.map((val: string, index: number) => {
          const isChecked = val === value;
          return (
            <FormControlLabel
              tabIndex={0}
              onKeyDown={onEnterOrEscapeKeyDown}
              key={index}
              value={val}
              control={
                <Radio
                  sx={{
                    display: 'none',
                  }}
                />
              }
              label={val}
              sx={{
                ml: 0,
                backgroundColor: isChecked ? 'purple2.shade_200' : '#fff',
                p: '16px 24px',
                border: '1px solid',
                borderColor: 'purple2.shade_400',
                borderRadius: '12px',
                '& .MuiTypography-root': {
                  fontWeight: 400,
                  fontSize: isDesktop ? '20px' : '16px',
                  lineHeight: '24px',
                  fontFamily: 'inherit',
                },
                ...valueSx,
              }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
